import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { MessageService } from './message.service';
import { tap } from 'rxjs/operators';


export interface CreateAccountRequest {
    email: string;
    username: string;
    password: string;
    confirmPassword: string;
}
export interface TokenValidationRequest {
  otp: string;
}
export interface StartResetPasswordRequest {
  email: string;
}
export interface ResetPasswordRequest {
  token: string;
  password: string;
  passwordConfirm: string;
}
@Injectable({ providedIn: 'root' })
export class AccountService {


    private readonly baseUrl = environment.http.apiRoot;
    constructor(private http: HttpClient, private messageService: MessageService) { }

    signup(createAccountRequest: CreateAccountRequest): Observable<any> {
      return this.http.post(`${this.baseUrl}/account/signup`, createAccountRequest).pipe(
        tap(res => this.messageService.handleSuccess('SIGNUP.MESSAGES.REQUEST.SUCCESS'))
      );
    }


    verifyOtp(code: string, type:string='ACCOUNT_ACTIVATION'): Observable<any> {
      const params = new HttpParams().set('code', code).set('type', type);
      return this.http.get<any>(`${this.baseUrl}/account/otp`, {params});
    }

    activate(activateAccountTokenRequest: TokenValidationRequest): Observable<any> {
      return this.http.post(`${this.baseUrl}/account/signup/activate`, activateAccountTokenRequest).pipe(
        tap(res => this.messageService.handleSuccess('SIGNUP.MESSAGES.ACTIVATION.SUCCESS'))
      );
    }

    startResetPassword(startResetPasswordRequest: StartResetPasswordRequest): Observable<any> {
      return this.http.post(`${this.baseUrl}/account/resetPassword`, startResetPasswordRequest).pipe(
        tap(res => this.messageService.handleSuccess('RESET_PASSWORD.MESSAGES.REQUEST.SUCCESS'))
      );
    }

    // validateResetPasswordToken(resetPasswordTokenRequest: TokenValidationRequest) {
    //     return this.http.post(`${this.baseUrl}account/password/validateToken`, resetPasswordTokenRequest);
    // }

    executeResetPassword(resetPasswordRequest: ResetPasswordRequest) {
        return this.http.put(`${this.baseUrl}/account/resetPassword`, resetPasswordRequest).pipe(
          tap(res => this.messageService.handleSuccess('RESET_PASSWORD.MESSAGES.RESET.SUCCESS'))
        );
    }
}
